import styled from 'styled-components';

export const GoSafeCardBlockWrapper = styled.div(
  props => `
   margin-top: ${props.theme.spacing.base};
  `,
);

export const SeoSrpContainerDiv = styled.section(
  props => `

  background-color: ${props.theme.colors.goWhite.base};
  width: 100%;
  flex-direction: column;
  padding: ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.custom(10)};
`,
);

export const SeoSrpHeaderPara = styled.p(
  props => `

  width: 100%;
  padding-bottom: ${props.theme.spacing.xlarge};
  font-size: ${props.theme.font.custom(18)};
  font-family: ${props.theme.font.fontFamily};
  font-weight:bold;
`,
);

export const SeoSrpContentDiv = styled.div(
  props => `
    display:flex;
    width:100%;
    flex-wrap:wrap;
    li{
      list-style-type: none;
      width:25%;
      display:flex;
      justify-content:space-between;
      padding-right:${props.theme.spacing.custom(30)};
      padding-bottom: ${props.theme.spacing.xlarge};
      &:last-child{
        // padding-right:0;
      }
  `,
);

export const TestDiv = styled.div(
  props => `
  width:25%;
  display:flex;
  justify-content:space-between;
  padding-right:${props.theme.spacing.custom(30)};

`,
);

export const CityLink = styled.a(
  props => `
  text-decoration: none;
  color: ${props.theme.colors.goBrandBlue.base};
  font-size:${props.theme.font.custom(14)};
`,
);

export const CityNumberSpan = styled.span(
  props => `
  text-decoration: none;
  color: ${props.theme.colors.downriver.base};
  font-size:${props.theme.font.custom(14)};

`,
);

export const ShowAllLink = styled.a(
  props => `
  //display:flex;
  display:block;
  text-decoration: none;
  color: ${props.theme.colors.goBrandBlue.base};
  font-size:${props.theme.font.custom(14)};
  font-weight:bold;
  padding-bottom: ${props.theme.spacing.large};
  text-align:right;
  padding-right: 3rem;
`,
);
